import React, { useState } from 'react';
import { AppBar, Toolbar, IconButton, Box } from '@mui/material';
import { RiCloseLargeLine } from "react-icons/ri";
import { HiMenuAlt2 } from "react-icons/hi";
import './Header.scss';
import NavLinks from './NavLinks/NavLinks';
import UserMenu from './UserMenu/UserMenu';
import ContactInfo from './ContactInfo/ContactInfo';
import DrawerMenu from './DrawerMenu/DrawerMenu';
const Header = ({phoneNumber, logo, logo2, dir, navLinks, t ,onLogout,isLoggedIn,user}) => {
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const toggleDrawer = (open) => {
        setDrawerOpen(open);
        if (!open) setIsMenuOpen(false);
    };
    const handleHamburgerClick = () => {
        setIsMenuOpen(!isMenuOpen);
        toggleDrawer(!drawerOpen);
    };
    return (
        <>
            <AppBar position="sticky" className="header" sx={{ backgroundColor: 'var(--secondary-color)', boxShadow: '0px 4px 8px rgba(199, 199, 199, 0.5)' }}>
                <Toolbar className="header-content" >
                    {/* Hamburger Menu for Mobile */}
                    <IconButton
                        edge="start"
                        color="inherit"
                        aria-label="menu"
                        sx={{
                            display: { xs: 'block', md: 'none' }, // Only show hamburger on xs and sm screens
                            // backgroundColor: 'var(--secondary-color)', 
                            borderRadius: '50%',
                            padding: '8px',
                            width: "40px",
                            height: "40px",
                            transition: 'transform 0.3s ease',
                            '&:hover': {
                                backgroundColor: 'var(--primary-color-hover)',
                                '& svg': {
                                    color: 'var(--secondary-color)',
                                }
                            },
                            '&.active': {
                                transform: 'rotate(180deg)',
                            }
                        }}
                        onClick={handleHamburgerClick}
                        className={isMenuOpen ? 'active' : ''}
                    >
                        {isMenuOpen ? (
                            <RiCloseLargeLine style={{ fontSize: '24px', color: 'var(--primary-color)' }} />
                        ) : (
                            <HiMenuAlt2 style={{ fontSize: '24px', color: 'var(--primary-color)' }} />
                        )}
                    </IconButton>
                    {/* Language Dropdown and User Menu (only on larger screens) */}
                    <Box sx={{ display: { xs: 'none', md: 'flex' }, justifyContent: "space-between", gap: 2 }}>
                        <UserMenu loggedIn={isLoggedIn} direction={dir} t={t} onLogout={onLogout} user={user}/>
                    </Box>

                    {/* Navigation Links (only shown on larger screens) */}
                    <Box sx={{ display: { xs: 'none', md: 'flex' }, justifyContent: 'center', width: '100%' }}>
                        <NavLinks links={navLinks} direction={dir} />
                    </Box>
                    {/* Contact Info and Logo */}
                    <ContactInfo logo={logo} logo2={logo2} t={t} direction={dir} phoneNumber={phoneNumber}/>
                </Toolbar>
            </AppBar>

            {/* Drawer for Mobile */}
            <DrawerMenu
                navLinks={navLinks}
                drawerOpen={drawerOpen}
                toggleDrawer={toggleDrawer}
                loggedIn={isLoggedIn}
                logo={logo}
                t={t} direction={dir}
                onLogout={onLogout}
            />
        </>
    );
};

export default Header;
